import { render, staticRenderFns } from "./ResetEmail.vue?vue&type=template&id=b04cea52&"
import script from "./ResetEmail.vue?vue&type=script&lang=js&"
export * from "./ResetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports